// Centralized environment configuration for Customer Portal
// NOTE: In CRA, only REACT_APP_* variables are exposed to the browser

// ⚠️ SECURITY: No hardcoded keys! All keys must come from environment variables.
// If env vars are missing, the app will fail fast rather than use insecure defaults.

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate that required env vars exist
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  const missing = [];
  if (!SUPABASE_URL) missing.push('REACT_APP_SUPABASE_URL');
  if (!SUPABASE_ANON_KEY) missing.push('REACT_APP_SUPABASE_ANON_KEY');

  console.error(
    `❌ Missing required environment variables: ${missing.join(', ')}\n` +
    `Please check your .env file and restart the dev server.`
  );
}

// Convenience headers for REST calls
export function supabaseAnonHeaders() {
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  };
}
